export enum DeviceFamily {
  TOUCH = 'touch',
  WATER = 'water',
  PROXIMITY = 'proximity',
  TEMPERATURE = 'temperature',
  AIR_QUALITY = 'airQuality',
  PIR = 'pir',
  QR_CODE = 'qrCode',
  GATEWAY = 'gateway',
  HUMIDITY = 'humidity',
  CO2 = 'co2',
  TVOC = 'tvoc',
  GAS = 'gas',
  ELECTRICITY = 'electricity',
  PHOTOVOLTAIC = 'photovoltaic',
  FUEL = 'fuel',
  THERMAL = 'thermal',
  DEFAULT = 'default',
  CHLORINE = 'chlorine',
  PH = 'ph',
}
